var map = {
	"./Osterfeuer-brennt.jpg": "bc0b",
	"./Osterfeuer.jpg": "2422",
	"./Pfingstbaum-Baumtruppe.jpg": "8dfd",
	"./Pfingstbaum-Platz.jpg": "b472"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9d2d";